// ============================================================
// src/pages/auth/StravaCallback.js
// Rollaco Cycling Academy — Tahap 4 (token di Supabase)
// ============================================================

import { useEffect, useState } from 'react'
import { stravaExchangeToken, saveStravaTokens } from '../../lib/strava'
import { supabase } from '../../lib/supabase'

export default function StravaCallback({ onSuccess, onError }) {
  const [status, setStatus]     = useState('loading')
  const [errorMsg, setErrorMsg] = useState('')

  useEffect(() => {
    const handleCallback = async () => {
      const params = new URLSearchParams(window.location.search)
      const code   = params.get('code')
      const error  = params.get('error')

      if (error || !code) {
        setErrorMsg('Akses Strava ditolak atau dibatalkan.')
        setStatus('error')
        return
      }

      try {
        // Ambil profile user yang sedang login
        const { data: { session } } = await supabase.auth.getSession()
const user = session?.user
if (!user) {
  // Tunggu sebentar dan coba lagi
  await new Promise(r => setTimeout(r, 1000))
  const { data: { session: session2 } } = await supabase.auth.getSession()
  if (!session2?.user) throw new Error('Sesi login tidak ditemukan.')
}
const finalUser = user || (await supabase.auth.getSession()).data.session?.user

        // Tukar code → token
        const tokenData = await stravaExchangeToken(code)

        // Simpan token ke Supabase (bukan localStorage)
        await saveStravaTokens(finalUser.id, tokenData)

        setStatus('success')
        setTimeout(() => onSuccess && onSuccess(), 1500)

      } catch (err) {
        setErrorMsg(err.message || 'Gagal menghubungkan Strava.')
        setStatus('error')
      }
    }

    handleCallback()
  }, [])

  if (status === 'loading') return (
    <div style={wrapStyle}>
      <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>🔄</div>
      <div style={{ color: '#fb923c', fontWeight: 'bold', fontSize: '1.1rem' }}>
        Menghubungkan Strava...
      </div>
      <div style={{ color: '#94a3b8', fontSize: '0.8rem', marginTop: '0.5rem' }}>
        Mohon tunggu sebentar
      </div>
    </div>
  )

  if (status === 'success') return (
    <div style={wrapStyle}>
      <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>✅</div>
      <div style={{ color: '#34d399', fontWeight: 'bold', fontSize: '1.1rem' }}>
        Strava berhasil terhubung!
      </div>
      <div style={{ color: '#94a3b8', fontSize: '0.8rem', marginTop: '0.5rem' }}>
        Kembali ke dashboard...
      </div>
    </div>
  )

  return (
    <div style={wrapStyle}>
      <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>❌</div>
      <div style={{ color: '#ef4444', fontWeight: 'bold', fontSize: '1.1rem' }}>
        Koneksi Strava Gagal
      </div>
      <div style={{
        color: '#94a3b8', fontSize: '0.8rem',
        marginTop: '0.5rem', marginBottom: '1.5rem',
        maxWidth: '280px', textAlign: 'center', lineHeight: 1.6,
      }}>
        {errorMsg}
      </div>
      <button
        onClick={() => onError && onError()}
        style={{
          padding: '0.6rem 1.5rem',
          background: '#1e293b',
          border: '1px solid #334155',
          borderRadius: '8px',
          color: '#94a3b8',
          cursor: 'pointer',
          fontSize: '0.85rem',
        }}
      >
        ← Kembali
      </button>
    </div>
  )
}

const wrapStyle = {
  minHeight: '100vh',
  background: '#0f172a',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  color: '#f1f5f9',
}


